var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngleDoubleRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.879 12.7069L10.987 22.5999L12.4 24.0129L22.293 14.1209C22.8554 13.5584 23.1714 12.7954 23.1714 11.9999C23.1714 11.2044 22.8554 10.4415 22.293 9.87894L12.408 -0.00606631L10.994 1.40794L20.878 11.2929C21.0656 11.4803 21.1711 11.7346 21.1713 11.9997C21.1715 12.2649 21.0664 12.5193 20.879 12.7069Z",
    fill: "#F6DACF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.99997 22.5829L2.41697 23.9999L13.707 12.7099C13.8944 12.5224 13.9998 12.2681 13.9998 12.0029C13.9998 11.7377 13.8944 11.4834 13.707 11.2959L2.41597 -0.000107824L0.999971 1.41589L11.586 11.9999L0.99997 22.5829Z",
    fill: "#F6DACF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24 24) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDoubleRight);
export default __webpack_public_path__ + "static/media/angle-double-right.965b0e3c364da84a10ec2a1cb6490d6a.svg";
export { ForwardRef as ReactComponent };